import React, { useState } from 'react';
import PropTypes from 'prop-types';
import postApi from 'utils/api/post/PostApi';
import {
  Button, Icon, Modal, message,
} from 'antd';
import './PublishForm.less';

const { localStorage } = window;

const PublishModal = (props) => {
  // Receive the offertype (e.g. general offer,single flight)
  // Receive data.
  const {
    handleRedirect,
    mongoID,
    offerType,
    postToEdit,
    updatePostHandler,
    data, // TODO: Verify ehy it does not render when we just change the push_notification value
  } = props;

  // TODO: Determinates if the error modal is necesary.
  const dataReady = true;
  // Publish Modal
  const [visiblePublish, setVisiblePublish] = useState(false);
  // Error Modal
  const [visibleError, setVisibleError] = useState(false);

  const token = localStorage.getItem('token');
  /**
   * uploadPostHandler
   * @returns {Promise<void>}
   */
  const publishPostHandler = async () => {
    try {
      if (data.push_notification) {
        if (!data.push_notification.lowest_price) {
          if (data.type === 1) {
            data.push_notification.lowest_price = 0;
          } else {
            data.push_notification.lowest_price = data.lowest_price;
          }
        }
      }
      const response = await postApi.changeStatus({ action: 'publish', push_notification: data.push_notification }, mongoID, token);
      if (response.status === 200) {
        const successMessage = {
          true: 'Se ha actualizado y publicado correctamente',
          false: 'Se ha publicado correctamente',
        };
        message.success(successMessage[postToEdit]);
        handleRedirect();
      }
    } catch (error) {
      message.error(error.toString());
    }
  };

  /**
   * Method to update and publish, call updatePostHandler prop
   */
  const updateAndPublishHandler = () => {
    updatePostHandler(true);
  };

  const handleOkPublish = () => {
    if (postToEdit) {
      updateAndPublishHandler();
    } else {
      publishPostHandler();
    }
    setVisiblePublish(false);
  };

  const handleCancelPublish = () => {
    setVisiblePublish(false);
  };

  const handleOkError = () => {
    setVisibleError(false);
  };

  return (
    <div>
      <Button
        className={`publish-button ${mongoID && 'publish-green-button'} `}
        disabled={mongoID === ''}
        onClick={dataReady ? () => setVisiblePublish(true) : () => setVisibleError(true)}
      >
        Publicar
      </Button>
      <Modal
        visible={visiblePublish}
        footer={[
          <Button key="back" onClick={handleCancelPublish}>
            No, cancelar
          </Button>,
          <Button key="submit" type="primary" onClick={handleOkPublish}>
            Sí, publicar
          </Button>,
        ]}
      >
        <h2>
          <Icon type="exclamation-circle" theme="filled" className="alert-icon" />
          {postToEdit
            ? `Actualizar y Publicar "${offerType}"`
            : `Publicar "${offerType}"`}
        </h2>
        <div className="modal-p">
          <p>
            {postToEdit
              ? `Estás a punto de actualizar y publicar un(a) "${offerType}"`
              : `Estás a punto de y publicar un/una "${offerType}"`}
          </p>
          <p>¿Deseas continuar?</p>
        </div>
      </Modal>
      <Modal
        visible={visibleError}
        footer={[
          <Button key="submit" type="primary" onClick={handleOkError}>
            Entendido
          </Button>,
        ]}
      >
        <h2>
          <Icon type="close-circle" theme="filled" className="error-icon" />
          Error
        </h2>
        <div className="publish-modal-paragraph">
          <p>Error, aún hay campos vacíos. Completa el formulario</p>
          <p>Aún hay campos faltantes</p>
        </div>
      </Modal>
    </div>
  );
};

PublishModal.propTypes = {
  handleRedirect: PropTypes.func.isRequired,
  mongoID: PropTypes.string.isRequired,
  offerType: PropTypes.string.isRequired,
  postToEdit: PropTypes.bool.isRequired,
  updatePostHandler: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};

export default PublishModal;
